import { motion } from "framer-motion";

export const ChapterHeader = ({ index, title, heading, blurb, testid }) => (
  <div className="mb-16 max-w-3xl" data-testid={testid}>
    <motion.p
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7 }}
      className="flex items-center gap-4 text-xs uppercase tracking-[0.35em] text-white/50"
    >
      <span className="font-display text-lg italic text-sunset">{index}</span>
      <span className="h-px w-10 bg-white/20" />
      {title}
    </motion.p>
    <motion.h2
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: 0.1 }}
      className="mt-6 font-display text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl"
    >
      {heading}
    </motion.h2>
    {blurb && (
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-6 max-w-xl text-base font-light text-white/60 md:text-lg"
      >
        {blurb}
      </motion.p>
    )}
  </div>
);
